import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {
  ActionsAnalyticsService, IFireBasePlanItem, IUser, IUserAccount, IUserPlan, MobileCustomPlansServiceNoSync, MobilePlanItem,
  UserAccountServiceNoSync, UserPlansService
} from '@ztarmobile/zwp-service-backend';
import { take, takeWhile } from 'rxjs/operators';
import { MetaService } from '../../../../services/meta-service.service';
import { ModalHelper } from '../../../../services/modal-helper.service';
import {  ROUTE_URLS, SUPPORT_ROUTE_URLS } from '../../../app.routes.names';
import Swiper, { EffectCards, Keyboard, Navigation, Pagination, SwiperOptions } from 'swiper';
import { TERMS_AND_CONDITIONS_ROUTE_URLS } from '@app/support/terms-and-conditions/terms-and-conditions.routesName';

@Component({
  selector: 'app-change-plan-shop',
  templateUrl: './change-plan-shop.component.html',
  styleUrls: ['./change-plan-shop.component.scss']
})
export class ChangePlanShopComponent implements OnInit, OnDestroy {
  public innerWidth;
  public selectedPlan: IUserPlan;
  public selectedPlanInfo: IFireBasePlanItem;
  public userProfile: IUser;
  public isExpiredPlan = false;
  public userAccount: IUserAccount;
  public userplanId: string;
  public filteredPlans: Array<MobilePlanItem>;
  public cyclePlans: MobilePlanItem[];
  public monthlyPlans: Array<MobilePlanItem>;
  public allBasePlans: Array<MobilePlanItem>;
  public is12MonthsPlans = false;
  public subscriptionCycles = [1, 3, 6, 12];
  public selectedSubscription = 3;
  public swiper: any;
  public config: SwiperOptions = {
    direction: 'horizontal',
    keyboard: false,
    mousewheel: false,
    scrollbar: false,
    roundLengths: true,
    loopFillGroupWithBlank: true,
    slideToClickedSlide: true,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    initialSlide: 1,
    observer: true,
    effect: 'slide',
    enabled: true,
    centeredSlides: true,
    slidesPerView: 'auto',
    pagination: {
      el: '.slider-pagination',
      renderBullet: (index, className) => `<li style="z-index: 10" class="slick-active ${className}"><button ></button></li>`,
      clickable: true
    },
    spaceBetween: 20
  };

  private alive = true;
  nextCycle: boolean;
  nextCycleSelected: boolean;
  newPlan: any;

  constructor(private userPlansService: UserPlansService, private router: Router,
    private route: ActivatedRoute, private mobilePlansService: MobileCustomPlansServiceNoSync, private userAccountService: UserAccountServiceNoSync,
    private modalHelper: ModalHelper, private metaService: MetaService, private analyticsService: ActionsAnalyticsService,
    private cdr: ChangeDetectorRef) {
  
    this.mobilePlansService.isConfigurationReady.pipe(takeWhile(() => this.alive)).subscribe((isReady) => {
      if (isReady) {
        this.allBasePlans = this.mobilePlansService.allBasePlans;
        this.filteredPlans = this.allBasePlans.filter((plan) => !!plan.parentId);
        this.filteredPlans.sort((a, b) => a.details.data - b.details.data);
        this.monthlyPlans = this.filteredPlans.filter((plan) => plan.subscriptionCycles === 1);

        this.route.params.pipe(takeWhile(() => this.alive)).subscribe((params: Params) => {
          if (!!params && params[ROUTE_URLS.PARAMS.USER_PLAN_ID]) {
            const selectedPlanId = params[ROUTE_URLS.PARAMS.USER_PLAN_ID];
            this.userPlansService.getUserPlan(selectedPlanId).then((data) => {
              if (!!data) {
                this.selectedPlan = data;
                this.getUserAccount(this.selectedPlan);
                 this.selectedPlanInfo = this.selectedPlan?.basePlan;
                this.filteredPlans = this.filteredPlans.filter((plan) => plan.id !== this.selectedPlan.basePlan.id);
                this.filterCyclePlans();
              }
            });
          } else {
            const storedId = sessionStorage.getItem('plan_id');
            if (!!storedId) {
              this.userPlansService.getUserPlan(storedId).then((data) => {
                if (!!data) {
                  this.selectedPlan = data;
                  this.getUserAccount(this.selectedPlan);
                   this.selectedPlanInfo = this.selectedPlan?.basePlan;
                  this.filteredPlans = this.filteredPlans.filter((plan) => plan.id !== this.selectedPlan.basePlan.id);
                this.filterCyclePlans();
              }
              });
            }
          }
        });
        if (!!this.monthlyPlans) {
          this.trackImpressions(this.monthlyPlans);
        }
      }
    });
  }

  ngOnInit(): void {
    this.innerWidth = document.documentElement.clientWidth;
    this.metaService.createCanonicalUrl();
    this.cdr.detectChanges();
    this.checkCreatingSwiper();
  }

  ngOnDestroy(): void {
    this.alive = false;
  }

  filterCyclePlans () {
    this.cyclePlans = this.filteredPlans.filter((plan) => plan.subscriptionCycles === this.selectedSubscription);
  }

  redirectToDisclosure () {
    this.router.navigate([`${SUPPORT_ROUTE_URLS.BASE}/${SUPPORT_ROUTE_URLS.TERMS_AND_CONDITIONS}/${TERMS_AND_CONDITIONS_ROUTE_URLS.MOBILE_BROADBAND}`])
  }

  public createSwiper(): void {
    this.swiper = new Swiper('.change-plan-swiper-container', {
      hashNavigation: true,
      modules: [Navigation, Pagination, Keyboard],
      ...this.config,
    });
    this.cdr.detectChanges();
  }

  public createReponsiveSwiper(): void {
    this.swiper = new Swiper('.change-plan-swiper-container', {
      hashNavigation: true,
      modules: [Navigation, Pagination, Keyboard, EffectCards],
      ...this.config,
      slidesPerView: 'auto',
      initialSlide: 1,
      centeredSlides: true,
      centeredSlidesBounds: true,
      slidesOffsetBefore: 100,
      slidesOffsetAfter: 200,
      effect: 'cards',
      cardsEffect: {
        perSlideOffset: 20, // Space between cards in px
        perSlideRotate: 1, // Rotation of cards in degrees
        rotate: false
      }

    });
    this.cdr.detectChanges();
    this.swiper?.on('slideChange', () => {
    });
  }

  public selectSubscription(item): void {
    this.selectedSubscription = item;
    this.filterCyclePlans();
    this.cdr.detectChanges();
    this.checkCreatingSwiper();
  }

  public trackImpressions(plans): void {
    this.analyticsService.trackProductsImpressions(plans, 'Plans-list');
  }

  public showCountries(): void {
    this.modalHelper.showILDCountries();
  }

  public changePlan(plan): void {
    this.newPlan = plan;
    if (!this.isExpiredPlan) {
      this.modalHelper.showConfirmMessage(`
      <p class="first">
        If you <b>change plans now,</b> it will <b>take effect immediately,</b> and any remaining service balances may be lost.
      </p>
      <p class="second">
        If you <b>change plans at expiration,</b> the new <b>plan will start then</b> and its cost will be deducted from your main account balance.
      </p>`,
      {
        title: 'Before we continue..',
        okText: 'Change on Expiry Date',
        cancelText: 'Change Plan Now',
        enableHTML: true,
        customClass: 'change-plan-modal'
      }).afterClosed().subscribe((result) => {
        if (result !== undefined) {
          this.mobilePlansService.clearUserCart().then(() => {
            this.nextCycle = result;
            this.nextCycleSelected = true;
          });
        }
      });
    } else {
      this.modalHelper.showConfirmMessage(`<p class="first">If you <b>change plan now,</b> your plan change <b>will take effect immediately.</b></p>
      <p class="second">The cost will be deducted from your main account balance.</p>`, {
        title: 'Before we continue..',okText: 'Change plan now',enableHTML: true, customClass: 'change-expired-plan-modal'
      }).afterClosed().subscribe((result) => {

        if (result && result !== undefined) {
          this.mobilePlansService.clearUserCart().then(() => {
            this.nextCycle = false;
            this.nextCycleSelected = true;
          });
        }
      });
    }
  }

  public back(): void{
    this.nextCycleSelected = false;
    this.newPlan = null;
    this.selectSubscription(3);
  }
  public checkCreatingSwiper(): void {
    if (!!this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    if (this.innerWidth < 640) {
      this.cdr.detectChanges();
      this.createSwiper();
    }
  }
  private getUserAccount(plan): void {
    this.userAccountService.userAccounts.pipe(take(1)).subscribe((accounts) => {
      const account = accounts.find((planAccount) => planAccount.mdn === plan.mdn);
      if (!!account) {
        if (!!this.userAccount && this.userAccount.plan.bundleId.endsWith('EXP')) {
          this.isExpiredPlan = true;
        }
      }
    });
  }
  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    this.innerWidth = document.documentElement.clientWidth;
    this.checkCreatingSwiper();
  }

}
